// HttpService.js
import axios from "axios";
import Cookies from "js-cookie";

class HttpService {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      withCredentials: true,
      headers: {
        // Accept: "application/json",
        // "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
  }

  setToken() {
    const userDetails = Cookies.get("userDetails")
      ? JSON.parse(Cookies.get("userDetails"))
      : null;
    // console.log("Set Token :::", userDetails);
    if (userDetails && userDetails.data.token) {
      const token = userDetails.data.token; // Assuming token is stored in userDetails
      if (token) {
        this.axiosInstance.defaults.headers.common["Authorization"] =
          `Bearer ${token}`;
        // this.axiosInstance.defaults.headers.common["x-access-token"] = token; // Add x-access-token header
      } else {
        delete this.axiosInstance.defaults.headers.common["Authorization"];
        delete this.axiosInstance.defaults.headers.common["x-access-token"]; // Remove x-access-token header if token is null
      }
    }
  }

  async get(url, config = {}) {
    this.setToken();
    return this.axiosInstance.get(url, config);
  }

  async post(url, data = {}, config = {}) {
    this.setToken();
    return this.axiosInstance.post(url, data, config);
  }

  async put(url, data = {}, config = {}) {
    this.setToken();
    return this.axiosInstance.put(url, data, config);
  }

  async patch(url, data = {}, config = {}) {
    this.setToken();
    return this.axiosInstance.patch(url, data, config);
  }

  async delete(url, config = {}) {
    this.setToken();
    return this.axiosInstance.delete(url, config);
  }
}

export default new HttpService();

// HttpService.js
// import axios from "axios";
// import Cookies from "js-cookie";

// class HttpService {
//   constructor() {
//     this.axiosInstance = axios.create({
//       baseURL: process.env.REACT_APP_API_BASE_URL,
//       withCredentials: true,
//       // headers: {
//       //   "Content-Type": "application/json",
//       // },
//     });

//     this.setToken();
//   }

//   setToken() {
//     const userDetails = Cookies.get("userDetails")
//       ? JSON.parse(Cookies.get("userDetails"))
//       : null;
//     if (userDetails && userDetails.token) {
//       const token = userDetails.token;
//       this.axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//       this.axiosInstance.defaults.headers.common["x-access-token"] = token;
//     } else {
//       delete this.axiosInstance.defaults.headers.common["Authorization"];
//       delete this.axiosInstance.defaults.headers.common["x-access-token"];
//     }
//   }

//   setContentType(data) {
//     console.warn("Data::", data );
//     if (data instanceof FormData) {
//       delete this.axiosInstance.defaults.headers.common["Content-Type"];
//       // this.axiosInstance.defaults.headers.common["Content-Type"] =
//         // "multipart/form-data";
//     } else {
//       this.axiosInstance.defaults.headers.common["Content-Type"] = "application/json";
//     }
//   }

//   async get(url, config = {}) {
//     this.setToken();
//     return this.axiosInstance.get(url, config);
//   }

//   async post(url, data = {}, config = {}) {
//     this.setToken();
//     this.setContentType(data);
//     return this.axiosInstance.post(url, data, config);
//   }

//   async put(url, data = {}, config = {}) {
//     this.setToken();
//     this.setContentType(data);
//     return this.axiosInstance.put(url, data, config);
//   }

//   async patch(url, data = {}, config = {}) {
//     this.setToken();
//     this.setContentType(data);
//     return this.axiosInstance.patch(url, data, config);
//   }

//   async delete(url, config = {}) {
//     this.setToken();
//     return this.axiosInstance.delete(url, config);
//   }
// }

// export default new HttpService();
